import en from './en';
import hr from './hr';
import de from './de';
import fr from './fr';

// Export all translations
const translations = {
  en,
  hr,
  de,
  fr
};

export default translations;
